// 确保引入 axios
// import axios from 'axios';
import request from "../../util/request";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Alipay.vue',
  data() {
    return {
      userCounts: [10, 30, 50],
      selectedUserCountIndex: -1,
      accountBalance: 0,
      totalAmount: 0,
      paymentMethod: '',
      isModalVisible: false,
      // 控制弹窗显示
      rechargeAmount: '',
      // 用于绑定充值金额输入框的值

      // 新增的提示框相关属性
      isNotificationVisible: false,
      // 控制提示框显示
      notificationMessage: '' // 提示框的消息内容
    };
  },

  created() {
    this.load();
  },
  methods: {
    changeUserCount(change) {
      if (this.selectedUserCountIndex === -1) return;
      const newCount = this.userCounts[this.selectedUserCountIndex] + change;
      if (newCount >= 0) {
        this.userCounts[this.selectedUserCountIndex] = newCount;
        this.updateTotalAmount();
      }
    },
    selectUserCount(index) {
      this.selectedUserCountIndex = index;
      this.updateTotalAmount();
    },
    // 关闭提示框
    closeNotification() {
      this.isNotificationVisible = false;
      this.resetPaymentState();
    },
    // 显示提示框
    showNotification(message) {
      this.notificationMessage = message;
      this.isNotificationVisible = true;
    },
    updateTotalAmount() {
      this.totalAmount = this.selectedUserCountIndex !== -1 ? this.userCounts[this.selectedUserCountIndex] * 1 : 0;
    },
    selectPaymentMethod(method) {
      this.paymentMethod = method;
    },
    load() {
      console.log("234567890");
      const rentalUserIndex = sessionStorage.getItem("rentalUserIndex");
      console.log(rentalUserIndex);
      // const rentalUserIndex = "55a5002a-2623-4a8e-9a57-a28741a60517"; // 假设传递的 rentalId 值为 1
      request.get(`/alipay/querybalance?rentalUserIndex=${rentalUserIndex}`).then(res => {
        console.log(res);
        this.accountBalance = res;
        console.log(this.accountBalance);
      }).catch(error => {
        console.error('Error fetching balance:', error);
      });
    },
    // 显示充值弹窗
    rechargeBalance() {
      this.resetPaymentState();
      this.isModalVisible = true;
    },
    // 关闭弹窗
    closeModal() {
      this.isModalVisible = false;
      this.rechargeAmount = ''; // 清空输入框
    },

    // 提交充值金额
    submitRechargeAmount() {
      const amount = parseFloat(this.rechargeAmount);
      if (isNaN(amount) || amount <= 0) {
        alert('请输入有效的金额');
        return;
      }
      let map = {
        amount: amount,
        type: 3,
        //充值账户
        count: 0
      };
      request.post('/alipay/order', map).then(res => {
        if (res.code === '0' && res.data) {
          const paymentForm = res.data;
          const formContainer = document.createElement('div');
          formContainer.innerHTML = paymentForm;
          document.body.appendChild(formContainer);
          const formElement = formContainer.querySelector('form');
          if (formElement) {
            formElement.submit();
          } else {
            this.showNotification('支付表单未找到');
          }
          this.closeModal(); // 充值成功后关闭弹窗
        } else {
          // this.showNotification('充值失败，原因：' + (res.message || '未知错误'));
          this.showNotification('充值失败，请重新充值');
        }
      }).catch(error => {
        console.error(error);
        this.showNotification('充值请求出错');
      });
    },
    alipayPayment() {
      request.post('/alipay/order', {
        amount: parseFloat(this.totalAmount),
        type: 1,
        // 新增 type 参数，值为 1 表示支付宝支付
        count: this.userCounts[this.selectedUserCountIndex]
        // rentalUserIndex:sessionStorage.getItem("rentalUserIndex"),
      }).then(res => {
        console.log(res);
        // 判断返回的响应是否包含表单数据
        if (res.code === '0' && res.data) {
          // 确保返回的 res.data 是表单 HTML 字符串
          const paymentForm = res.data; // 这里获取到表单 HTML

          // 创建一个新的 div 元素，将表单 HTML 插入其中
          const formContainer = document.createElement('div');
          formContainer.innerHTML = paymentForm; // 将 HTML 字符串插入到 div 中

          // 将表单容器添加到页面
          document.body.appendChild(formContainer);

          // 查找插入的表单并提交
          const formElement = formContainer.querySelector('form');
          if (formElement) {
            formElement.submit(); // 自动提交表单
          } else {
            this.showNotification('支付表单未找到');
          }
        } else {
          this.showNotification('支付请求失败，请重新下单');
        }
      }).catch(error => {
        console.error(error);
        this.showNotification('支付请求出错');
      });
    },
    // 确认支付
    confirmPayment() {
      if (this.paymentMethod === 'balance') {
        if (this.accountBalance >= this.totalAmount) {
          // 余额足够，调用支付请求
          let map1 = {
            amount: parseFloat(this.totalAmount),
            count: this.userCounts[this.selectedUserCountIndex]
          };
          console.log(map1);
          request.post('/alipay/order1', map1).then(res => {
            console.log(res);
            if (res) {
              this.showNotification('支付成功');
              this.load();
              this.resetPaymentState();
            } else {
              this.showNotification('支付失败，请稍后再试');
            }
          }).catch(error => {
            console.error(error);
            this.showNotification('支付请求出错');
          });
        } else {
          this.showNotification('账户余额不足，请充值');
        }
      } else if (this.paymentMethod === 'alipay') {
        // 如果是支付宝支付，调用 alipayPayment 方法
        this.alipayPayment();
      } else {
        this.showNotification('请选择支付方式');
      }
    },
    resetPaymentState() {
      this.selectedUserCountIndex = -1; // 清空用户选择的数量
      this.paymentMethod = ''; // 清空支付方式
      this.totalAmount = 0; // 重置支付金额
    }
  }
};